module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--16.ff3975ba.svg";